export default __webpack_public_path__ + "assets/mp3/db711b0d175ce5bbb9dbf4a72d142780.mp3";